/** Escape closes one topmost surface; controls beneath it never receive the key. */
type Kind = "dialog" | "drawer" | "pip" | "toast";
const priority: Record<Kind, number> = { dialog: 4, drawer: 3, pip: 2, toast: 1 };
const layers: { id: symbol; kind: Kind; close: () => void }[] = [];
export function registerLayer(kind: Kind, close: () => void): () => void {
  const entry = { id: Symbol(), kind, close };
  layers.push(entry);
  return () => {
    const index = layers.indexOf(entry);
    if (index >= 0) layers.splice(index, 1);
  };
}
export const hasDialog = () => layers.some((layer) => layer.kind === "dialog");
export function dismissTopLayer(): boolean {
  const top = layers.reduce<(typeof layers)[number] | undefined>(
    (best, layer) => (!best || priority[layer.kind] >= priority[best.kind] ? layer : best),
    undefined,
  );
  if (!top) return false;
  top.close();
  return true;
}
export function isTyping(target: EventTarget | null): boolean {
  return (
    target instanceof Element &&
    !!target.closest("input, select, textarea, [contenteditable='true'], [role='textbox']")
  );
}
